define('GameDayCore/GDModel/ValueObjects/Boxscore/Boxscore',['require','exports','module','../ValueObjectFactory','./BoxPlayer','./BoxTeam','../Linescore/LinescoreInnings'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
		BoxPlayer = require('./BoxPlayer');

	VO.create(Boxscore, {
		findPlayer: function(pid, b_or_p) {
			var source = (b_or_p == "b") ? [].concat(this.away.batters, this.home.batters) : [].concat(this.away.pitchers, this.home.pitchers),
				i = 0,
				len = source.length;

			for (i; i < len; i++) {
				if (source[i].id == pid) {
					return new BoxPlayer(source[i]);
				}
			}

			return { }
		}
	});

	function Boxscore($data) {
		var vo = VO.ensureVO(this, Boxscore),
			data = $data,
			BoxTeam = require('./BoxTeam'),
			LinescoreInnings = require('../Linescore/LinescoreInnings'),
			home = new BoxTeam(data, "home"),
			away = new BoxTeam(data, "away"),
			linescore = data.linescore || {};

		/* 
		 * Add inning state to linescore so LinescoreInnings.js can set the proper Top/Bottom indicator. This was
		 * the only way I could properly tell if it was the top of bottom with the data being passed in. (if ther's no
		 * 'home' propery on the current innings 'inning_line_score', then it's not the bottom of the inning yet..)
		 */
		if(data.linescore.inning_line_score && data.linescore.inning_line_score instanceof Array) {
			linescore.inning_state = data.linescore.inning_line_score[data.linescore.inning_line_score.length - 1].hasOwnProperty("home") ? "Bottom" : "Top";
		} else {
			linescore.inning_state = data.linescore.inning_line_score.hasOwnProperty("home") ? "Bottom" : "Top";
		}

		linescore.status_ind = data.status_ind;

		var innings = new LinescoreInnings(linescore);
        linescore.inning_line_score =  linescore.innings = innings.innings;
        linescore.home = home;
        linescore.away = away;

		vo.gameID = data.game_id || "";
		vo.date = data.date || "";
		vo.gamePK = data.game_pk || "";
		vo.home_sport_code = data.home_sport_code || "mlb";
		vo.venueName = data.venue_name || "";
		vo.home = home;
		vo.home_team_code = data.home_team_code || "";
		vo.home_id = data.home_id || "";
		vo.home_full_name = data.home_fname || "";
		vo.home_sname = data.home_sname || "";
		vo.linescore = linescore;
		vo.home_hits = linescore.home_team_hits || "";
		vo.home_runs = linescore.home_team_runs || "";
		vo.home_errors = linescore.home_team_errors || "";
		vo.home_wins = data.home_wins || "";
		vo.home_loss = data.home_loss || "";
		vo.away = away;
		vo.away_team_code = data.away_team_code || "";
		vo.away_id = data.away_id || "";
		vo.away_full_name = data.away_fname || "";
		vo.away_sname = data.away_sname || "";
		vo.away_hits = linescore.away_team_hits || "";
		vo.away_runs = linescore.away_team_runs || "";
		vo.away_errors = linescore.away_team_errors || "";
		vo.away_wins = data.away_wins || "";
		vo.away_loss = data.away_loss || "";
		vo.game_info = data.game_info || "";
		vo.innings = innings.innings;
		vo.current_inning  = innings.inning;
		vo.hasOPS = home.batterTotals.ops != null;
	}

	return Boxscore;
});
